import { FC } from "react";

export const ResultsSkeleton: FC = () => {
  return (
    <div className="p-6 space-y-4">
      <div className="h-8 w-2/3 bg-neutral-200 rounded animate-pulse"></div>
      <div className="flex gap-2">
        <div className="h-6 w-20 bg-neutral-200 rounded-full animate-pulse"></div>
        <div className="h-6 w-28 bg-neutral-200 rounded-full animate-pulse"></div>
      </div>
      <div className="mt-6 space-y-3">
        {Array.from({ length: 5 }).map((_, i) => (
          <div
            key={i}
            className="h-12 bg-neutral-200 rounded-lg animate-pulse"
          ></div>
        ))}
      </div>
    </div>
  );
};
